import { default as RCTabs, TabsProps as BaseProps } from 'rc-tabs';
import 'rc-tabs/assets/index.css';
import React from 'react';
import classNames from 'classnames';
import TabItem from './tabs-item';
import { TabsSC } from './tabs.styled';
import { AbstractTabItemProps } from './tabs.types';

interface TabsProps extends Omit<BaseProps, 'items' | 'moreIcon'> {
  items: AbstractTabItemProps[];
}

const Tabs = (props: TabsProps, ref?: React.Ref<HTMLDivElement>) => {
  const mappedItems = React.useMemo(() => {
    return props.items.map((i) => ({
      ...i,
      label: <TabItem label={i.label} Icon={i.Icon} badge={i.badge} />,
    }));
  }, [props.items]);

  return (
    <TabsSC>
      <RCTabs
        {...props}
        ref={ref}
        items={mappedItems}
        className={classNames('ui-tabs', props.className)}
        moreIcon={null}
      />
    </TabsSC>
  );
};

export default React.forwardRef(Tabs);
